import constate from "constate";

import { type PlacementDetail } from "../../api/useGetPlacement";

function usePlacementDetailsProvider(props: { placementDetails: PlacementDetail }) {
  const { placementDetails } = props;
  return placementDetails;
}

export const [PlacementDetailsProvider, usePlacementDetails] = constate(
  usePlacementDetailsProvider
);
